module.exports = __webpack_public_path__ + "img/bg1.158ef795.jpg";